const NO_REDIRECT_PARAM = 'no-redirect'

export const hasNoRedirectParam = () => {
  const params = window.location.search
  return params.includes(NO_REDIRECT_PARAM)
}

export function isValidUrl(url: string): boolean {
  return !!url.match(/^https?:\/\/.*\.(amplify\.com|desmos\.com)/)
}
